import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type RSTimeframe = "7d" | "30d" | "90d";
export type Benchmark = "btc" | "eth";

export interface RelativeStrengthRow {
  coin_id: string;
  coin_symbol: string;
  coin_name: string;
  timeframe: string;
  coin_return: number;
  btc_return: number;
  eth_return: number;
  vs_btc_alpha: number;
  vs_eth_alpha: number;
  vs_btc_ratio: number;
  vs_eth_ratio: number;
  computed_at: string;
}

export function useRelativeStrength() {
  return useQuery({
    queryKey: ["relative-strength-all"],
    queryFn: async (): Promise<RelativeStrengthRow[]> => {
      const { data, error } = await supabase
        .from("relative_strength_data" as any)
        .select("*");
      if (error) throw error;
      return ((data ?? []) as any[]).map((r) => ({
        ...r,
        coin_return: Number(r.coin_return),
        btc_return: Number(r.btc_return),
        eth_return: Number(r.eth_return),
        vs_btc_alpha: Number(r.vs_btc_alpha),
        vs_eth_alpha: Number(r.vs_eth_alpha),
        vs_btc_ratio: Number(r.vs_btc_ratio),
        vs_eth_ratio: Number(r.vs_eth_ratio),
      })) as RelativeStrengthRow[];
    },
    staleTime: 10 * 60 * 1000,
  });
}
